var windowWidth;
var windowHeight;
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
EMMY = {
    common: {
        init: function () {
            console.log('init');

            $('#SaveButtonOutsideVue').on('click', function(e) {
                e.preventDefault();
                $('form #NextButton').click();
            });
        },

    }
}
